import { Trans } from "react-i18next";

export const Unauthorized = () => {
  return (
    <div>
      <Trans>Unauthorized</Trans>
    </div>
  );
};
